<!-- Static Images and Dynamic Images if we have a partialCredential -->
<!-- Need src attribute for the standalone credential renderer to work -->
<!-- Hide image if src is invalid. This happens when it's a custom image attribute and is displayed as a group -->
@if (isImageUrlValid) {
  <img
    class="block-image"
    [alt]="block().alt_text || ''"
    [src]="imgSrc"
    [lazyLoad]="imgSrc"
    (onStateChange)="imageLoadUpdate($event)" />
}
